import Axios from 'axios';

const state = () => ({
  events: [],
});

const actions = {
  loadEvent({ commit }) {
    Axios.get(process.env.VUE_APP_API + 'events')
      .then(response => {
        commit('SET_EVENTS', response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
};
const mutations = {
  SET_EVENTS(state, data) {
    state.events = data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
